"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.findLongestDimension = findLongestDimension;
function findLongestDimension(lines) {
    return lines
        .flatMap(line => (line.dimensions ? Object.values(line.dimensions) : [0]))
        .reduce((longestDimension, dimension) => (longestDimension > dimension ? longestDimension : dimension), 0);
}
